import {
	Button, Accordion, AccordionDetails, AccordionSummary,
	FormControl, InputLabel, MenuItem, Stack, TextField
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import * as turf from "@turf/turf";
import { addLocationSetItems, getLocationsetsItems, patchLocationsetsItems } from "api/layer";
import china from "assets/json/c1.json";
import countryArray from "assets/json/country.json";
import Icon from "components/icon/icon";
import Modal from "components/modal/modal";
import { LeftPanel, RightPanel, OccupancyOptions } from "helpers/constants";
import { AppAction, AppContext, setLeftPanel } from "helpers/context";
import { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./add-location.module.scss";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { NumericFormat } from 'react-number-format';
import dayjs from "dayjs";
import "dayjs/locale/en"; // 导入中文语言包
import "dayjs/locale/zh"; // 导入中文语言包

interface LocationData {
	locationSetId: string;
	code: string;
	name: string;
	country: string;
	county: string;
	longitude: string;
	latitude: string;
	number: string;
	place: string;
	province: string;
	street: string;
	zipCode: string;
	countryISO3: string;
	coordinateSource: string;
	coordinateSystem: string;
	_amapMarker?: any;
	insuredName: string;
	insuredCode: string;
	inceptionDate: any;
	expirationDate: any;
	evaluationDate: any;
	currency: string;
	perilsCovered: string;
	occupancy: string;
	numberOfRisks: string;
	building: string;
	content: string;
	businessInterruption: string;
	propertyDamage: string;
	limit: string;
	deductible: string;
	other: string;
	total: string;
}

export default function AddLocation() {
	const [context, dispatch] = useContext(AppContext);
	const locationSets = context.locationSets;
	const [t] = useTranslation();

	const options = locationSets || [];
	const locationSetId: string = context.currentMultipleLocations ? context.currentMultipleLocations.id : "";
	let LocationData = {
		locationSetId,
		code: "",
		name: "",
		country: "",
		county: "",
		longitude: "",
		latitude: "",
		number: "",
		place: "",
		province: "",
		street: "",
		zipCode: "",
		countryISO3: "",
		coordinateSource: "addLocation",
		coordinateSystem: "",
		insuredName: "",
		insuredCode: "",
		inceptionDate: null,
		expirationDate: null,
		evaluationDate: null,
		currency: "",
		perilsCovered: "",
		occupancy: "",
		numberOfRisks: "",
		building: "",
		content: "",
		businessInterruption: "",
		propertyDamage: "",
		limit: "",
		deductible: "",
		other: "",
		total: "",
	};

	if (context.leftPanel === LeftPanel.AddLocation && context.searchLocationInfo) {
		const locationInfo = context.searchLocationInfo[context.language];

		const country = typeof locationInfo.country === "string" ? locationInfo.country : "";
		const county = typeof locationInfo.district === "string" ? locationInfo.district : "";
		const longitude = locationInfo.location.split(",")[0];
		const latitude = locationInfo.location.split(",")[1];
		const number = locationInfo.streetNumber && typeof locationInfo.streetNumber.number === "string" ? locationInfo.streetNumber.number : "";
		const place = typeof locationInfo.formatted_address === "string" ? locationInfo.formatted_address : "";
		const province = typeof locationInfo.province === "string" ? locationInfo.province : "";
		const street = locationInfo.streetNumber && typeof locationInfo.streetNumber.street === "string" ? locationInfo.streetNumber.street : "";
		const zipCode = typeof locationInfo.adcode === "string" ? locationInfo.adcode : "";
		let countryISO3 = "";
		if (country) {
			const countryItem = countryArray.filter((item) => item.label.toLowerCase().includes(country.toLowerCase()))[0];
			if (countryItem) {
				countryISO3 = countryItem.iso3;
			}
		}

		LocationData = {
			locationSetId,
			code: "",
			name: "",
			country,
			county,
			longitude,
			latitude,
			number,
			place,
			province,
			street,
			zipCode,
			countryISO3,
			coordinateSource: "addLocation",
			coordinateSystem: "",
			insuredName: "",
			insuredCode: "",
			inceptionDate: null,
			expirationDate: null,
			evaluationDate: null,
			currency: "",
			perilsCovered: "",
			occupancy: "",
			numberOfRisks: "",
			building: "",
			content: "",
			businessInterruption: "",
			propertyDamage: "",
			limit: "",
			deductible: "",
			other: "",
			total: "",
		};
	} else {
		LocationData = {
			...context.editMultipleLocation,
			locationSetId,
			inceptionDate: context.editMultipleLocation?.inceptionDate && dayjs(context.editMultipleLocation.inceptionDate),
			expirationDate: context.editMultipleLocation?.expirationDate && dayjs(context.editMultipleLocation.expirationDate),
			evaluationDate: context.editMultipleLocation?.evaluationDate && dayjs(context.editMultipleLocation.evaluationDate),
		};
	}

	const [Location, setLocation] = useState<LocationData>(LocationData);
	const [disabled, setDisabled] = useState(false);
	const [isError, setIsError] = useState(false);
	const [isChange, setIsChange] = useState(false);
	const [isClose, setIsClose] = useState(false);
	const [Loading, setLoading] = useState(false);
	const [errors, setErrors] = useState<any>({})

	const MAX_VALUE = 1000000000000000;

	const handleSetHiddenLocationsSnackBar = (data: any) => {
		const unit = data.aggregationUnit;
		const hasItems = Boolean(data.items?.length);
		const isValidUnit = unit !== "numberOfLocations";
		// 主逻辑判断

		if (hasItems && isValidUnit) {
			let hiddenLocationsArr = data.items?.filter((item: any) => !item[unit]) || [];
			dispatch({
				type: AppAction.setCurrentHiddenLocationsModal,
				payload: {
					open: false,
					tableData: hiddenLocationsArr
				}
			})
			if (hiddenLocationsArr.length) {
				dispatch({
					type: AppAction.addSnackBarParams,
					payload: {
						titleIcon: "warning",
						titleIconColor: "#ffa02f",
						title: "locationsWereHidden",
						titleData: hiddenLocationsArr.length,
						message: "locationsWereHiddenMessage",
						messageData: t("locations." + unit),
						footBtn: () => {
							return <Button
								color="success"
								style={{ marginRight: '10px' }}
								onClick={() => {
									dispatch({
										type: AppAction.setCurrentHiddenLocationsModal,
										payload: {
											tableData: hiddenLocationsArr,
											open: true,
										}
									})
									dispatch({ type: AppAction.popSnackBarParams })
								}}>
								{t("buttons.viewDetails")}
							</Button>
						}
					}
				})
			}
		} else {
			dispatch({
				type: AppAction.setCurrentHiddenLocationsModal,
				payload: undefined
			})
		}
	}

	const save = async () => {
		setDisabled(true);
		let errorsArr = Object.values(errors).filter(v => v);
		if (!(Location.locationSetId && Location.code && Location.name && Location.longitude && Location.latitude) || errorsArr.length > 0) {
			setDisabled(false);
			setIsError(true);
			dispatch({
				type: AppAction.addSnackBarParams,
				payload: {
					titleIcon: "error",
					titleIconColor: "red",
					title: "errorsInLocationForm",
					message: "pleaseFixTheErrors",
				}
			})
			return;
		}
		setIsError(false);
		setLoading(true);
		let params: any = { ...Location };
		params.inceptionDate = params.inceptionDate?.format("YYYY-MM-DD");
		params.expirationDate = params.expirationDate?.format("YYYY-MM-DD");
		params.evaluationDate = params.evaluationDate?.format("YYYY-MM-DD");
		if (context.leftPanel === LeftPanel.AddLocation) {
			dispatch({ type: AppAction.setMultipleLocationsSetLoadings, payload: true });
			try {
				const longitude = parseFloat(params.longitude);
				const latitude = parseFloat(params.latitude);
				if (isNaN(longitude) || isNaN(latitude)) {
					setDisabled(false);
					setIsError(true);
					return;
				}

				const point = turf.point([longitude, latitude]);
				const chinaGeojson = turf.polygon(china.features[0].geometry.rings);
				const isChina = turf.booleanPointInPolygon(point, chinaGeojson);
				if (isChina) {
					params.coordinateSystem = "GCJ02";
				} else {
					params.coordinateSystem = "WGS84";
				}
				let res = await addLocationSetItems(params.locationSetId, params);
				let resItems: any = [];
				let updatedLocationSets = [...(locationSets || [])];
				let currentMultipleLocations: any = {};

				for (let i = 0; i < updatedLocationSets.length; i++) {
					const item = updatedLocationSets[i];

					if (item.id !== res.data.locationSetId) continue;

					let newItems = item.items;

					// 1. items 为空 -> 重新拉取
					if (newItems === null) {
						resItems = await getLocationsetsItems(params.locationSetId);
						newItems = resItems.data.items.map((itm: any) => ({
							...itm,
							checked: true
						}));
					} else {
						// 2. items 已存在 -> 只追加
						newItems = [...(newItems || []), { ...res.data, checked: true }];
					}

					const newItemCount =
						item.itemCount === null
							? resItems?.data?.itemCount
							: (item.itemCount ?? 0) + 1;

					const updatedItem = {
						...item,
						items: newItems,
						itemCount: newItemCount
					};

					currentMultipleLocations = updatedItem;
					updatedLocationSets[i] = updatedItem;

					dispatch({
						type: AppAction.setCurrentMultipleLocations,
						payload: updatedItem
					});

					dispatch({
						type: AppAction.setMultipleLocationsSetLoadings,
						payload: false
					});

					break;
				}


				dispatch({ type: AppAction.setSearchLocationInfo, payload: undefined });
				dispatch({ type: AppAction.setSingleLocationAnalysed, payload: undefined });
				dispatch({
					type: AppAction.addSnackBarParams,
					payload: {
						title: "createdLocationTitle",
						messageData: params.name,
						message: "createdLocationMessage",
					},
				});
				if (currentMultipleLocations && currentMultipleLocations.id !== res.data.locationSetId) {
					dispatch({ type: AppAction.setMultipleLocationsAnalysed, payload: false });
				} else {
					handleSetHiddenLocationsSnackBar({ ...currentMultipleLocations })
				}
				dispatch({ type: AppAction.setMultipleLocationsEdit, payload: true })
				dispatch({ type: AppAction.setRightPanel, payload: RightPanel.Multiple });
				dispatch({ type: AppAction.setLocationSets, payload: [...updatedLocationSets] });
			} catch (error) {
				setDisabled(false);
			}
		} else {
			try {
				if (params._amapMarker) {
					delete params._amapMarker;
				}
				let res = await patchLocationsetsItems(context.currentMultipleLocations!.id, context.editMultipleLocation.id, params);
				let currentMultipleLocations = { ...context.currentMultipleLocations };
				currentMultipleLocations.items = currentMultipleLocations.items?.map((item) => {
					if (item.id === context.editMultipleLocation.id) {
						item = {
							...item,
							...res.data
						};
					}
					return item;
				});
				let updatedLocationSets = locationSets?.map((item) => {
					if (item.id === currentMultipleLocations.id) {
						item.items = currentMultipleLocations.items;
					}
					return item;
				});

				dispatch({ type: AppAction.setCurrentMultipleLocations, payload: currentMultipleLocations });
				dispatch({ type: AppAction.setLocationSets, payload: updatedLocationSets });
				dispatch({
					type: AppAction.addSnackBarParams,
					payload: {
						title: "editLocationTitle",
						messageData: context.editMultipleLocation.name,
						message: "editLocationMessage",
					},
				});
				dispatch({ type: AppAction.setEditMultipleLocation, payload: null });
				handleSetHiddenLocationsSnackBar(currentMultipleLocations)
			} catch (error) {
				setDisabled(false);
			}
		}
		setDisabled(false);
		setLoading(false);
		setLeftPanel(dispatch, LeftPanel.Locations);
	};

	const validateInteger = (name: string, value: string) => {
		if (value.trim() === "") return undefined;
		const num = Number(value);
		if (isNaN(num)) return t("locations.add.isNaN", { key: t("locations.add." + name) });
		if (num < 0) return t("locations.add.less0", { key: t("locations.add." + name) });
		if (num > MAX_VALUE) return t("locations.add.less9Q", { key: t("locations.add." + name) });
		return undefined;
	}


	const handleChange = (event: any) => {
		const { name, value, dataset } = event.target;

		if (name === "locationSetId" && value === "") {
			return;
		}

		if (context.leftPanel === LeftPanel.EditLocation && context.editMultipleLocation[name] === value) {
			setIsChange(false);
		} else {
			setIsChange(true);
		}

		if (dataset?.needNumber) {
			const result = validateInteger(name, value);
			setErrors((prev: any) => ({ ...prev, [name]: result }));
		}

		setLocation((prevData) => ({ ...prevData, [name]: value }));
	};

	const handleAddLocationSet = (e: any) => {
		dispatch({ type: AppAction.setCreateModal, payload: true });
	};

	const cancel = () => {
		if (context.leftPanel === LeftPanel.EditLocation && isChange) {
			setIsClose(true);
		} else {
			close();
		}
	};

	const close = () => {
		setLeftPanel(dispatch, LeftPanel.Locations);
		dispatch({ type: AppAction.setEditMultipleLocation, payload: null });
	};

	const handleDelete = () => {
		dispatch({
			type: AppAction.setDeleteLocationModal,
			payload: context.editMultipleLocation,
		});
	};

	const handleClose = () => {
		setIsClose(false);
	};

	useEffect(() => {
		if (context.currentMultipleLocations) {
			setLocation((prevData) => ({ ...prevData, locationSetId: context.currentMultipleLocations!.id }));
		}
	}, [context.currentMultipleLocations])

	return (
		<div className={styles.add}>
			<div className={styles.header}>
				<div className={styles.title}>
					<div className="flex items-center">
						<Icon
							icon="arrow_back"
							onClick={cancel}
						/>
						<span>{context.leftPanel === LeftPanel.EditLocation ? t("locations.add.editTitle") : t("locations.add.title")}</span>
					</div>
					<div>
						<Icon onClick={() => setLeftPanel(dispatch, LeftPanel.Empty)} />
					</div>
				</div>
			</div>
			{Loading ? (
				<div className={styles.loading}>
					<div className="loading loading-spinner loading-lg"></div>
					<div>{t("layers.savingLocation")}</div>
				</div>
			) : (
				<>
					<div className={styles.body}>
						<Stack spacing={{ xy: 1, sm: 2 }}>
							<FormControl fullWidth>
								<InputLabel
									required
									color="success"
								>
									{t("locations.add.Location_set")}
								</InputLabel>
								<Select
									required
									name="locationSetId"
									value={Location.locationSetId}
									disabled={context.leftPanel === LeftPanel.EditLocation}
									onChange={handleChange}
									error={isError && !Location.locationSetId}
									label={t("locations.add.Location_set")}
									color="success"
									MenuProps={{
										PaperProps: {
											style: {
												maxHeight: 350,
											},
										},
									}}
								>
									{options.map((option, index) => (
										<MenuItem
											key={index}
											value={option.id}
										>
											{option.name}({option.itemCount})
										</MenuItem>
									))}
									<MenuItem
										style={{ padding: 0, borderTop: "1px solid #0000001f", height: 45 }}
										value=""
									>
										<Button
											variant="text"
											color="success"
											style={{ width: "100%", height: "100%" }}
											onClick={handleAddLocationSet}
										>
											{t("single.addNewLocationSet")}
										</Button>
									</MenuItem>
								</Select>
							</FormControl>
							<TextField
								required
								name="code"
								value={Location.code}
								onChange={handleChange}
								error={isError && !Location.code}
								label={t("locations.add.code")}
								inputProps={{ maxLength: 50 }}
								variant="outlined"
								color="success"
							/>
							<TextField
								required
								name="name"
								value={Location.name}
								onChange={handleChange}
								error={isError && !Location.name}
								label={t("locations.add.name")}
								inputProps={{ maxLength: 500 }}
								variant="outlined"
								color="success"
							/>
							<Stack
								spacing={{ xs: 1 }}
								direction="row"
								useFlexGap
								sx={{ flexWrap: "wrap" }}
							>
								<TextField
									required
									sx={{ flex: 1 }}
									name="longitude"
									value={Location.longitude}
									onChange={handleChange}
									error={isError && !Location.longitude}
									label={t("locations.add.longitude")}
									variant="outlined"
									color="success"
								/>
								<TextField
									required
									sx={{ flex: 1 }}
									name="latitude"
									value={Location.latitude}
									onChange={handleChange}
									error={isError && !Location.latitude}
									label={t("locations.add.latitude")}
									variant="outlined"
									color="success"
								/>
							</Stack>
							<Accordion
								sx={{
									boxShadow: "none",
									backgroundColor: "transparent",
									margin: "12px 0 0!important",
									"&::before": {
										display: "none",
									},
								}}
							>
								<AccordionSummary
									expandIcon={<div className="material-icons">keyboard_arrow_right</div>}
									sx={{
										padding: 0,
										margin: 0,
										flexDirection: "row-reverse",
										"& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
											transform: "rotate(90deg)",
										},
										"& .MuiTypography-root": {
											fontFamily: "Roboto-Regular",
										},
										"&.Mui-expanded": {
											minHeight: "48px",
										},
										"& .MuiAccordionSummary-content.Mui-expanded": {
											margin: "12px 0",
										},
									}}
								>
									{t("locations.add.address")}
								</AccordionSummary>
								<AccordionDetails
									sx={{
										padding: "10px 0 0",
										width: "100%",
									}}
								>
									<Stack spacing={{ xy: 1, sm: 2 }}>
										<TextField
											// required
											name="zipCode"
											value={Location.zipCode}
											onChange={handleChange}
											label={t("locations.add.zipCode")}
											inputProps={{ maxLength: 30 }}
											variant="outlined"
											color="success"
										/>
										<Stack
											spacing={{ xs: 1 }}
											direction="row"
											useFlexGap
											sx={{ flexWrap: "wrap" }}
										>
											<TextField
												// required
												sx={{ flex: 1 }}
												name="street"
												value={Location.street}
												onChange={handleChange}
												label={t("locations.add.streetName")}
												inputProps={{ maxLength: 180 }}
												variant="outlined"
												color="success"
											/>
											<TextField
												// required
												sx={{ flex: 1 }}
												name="number"
												value={Location.number}
												onChange={handleChange}
												label={t("locations.add.streetNumber")}
												inputProps={{ maxLength: 50 }}
												variant="outlined"
												color="success"
											/>
										</Stack>
										<TextField
											// required
											name="place"
											value={Location.place}
											onChange={handleChange}
											label={t("locations.add.place")}
											inputProps={{ maxLength: 200 }}
											variant="outlined"
											color="success"
										/>
										<TextField
											// required
											name="county"
											value={Location.county}
											onChange={handleChange}
											label={t("locations.add.county")}
											inputProps={{ maxLength: 100 }}
											variant="outlined"
											color="success"
										/>
										<TextField
											// required
											name="province"
											value={Location.province}
											onChange={handleChange}
											label={t("locations.add.province")}
											inputProps={{ maxLength: 100 }}
											variant="outlined"
											color="success"
										/>
										<TextField
											// required
											name="country"
											value={Location.country}
											onChange={handleChange}
											label={t("locations.add.country")}
											inputProps={{ maxLength: 100 }}
											variant="outlined"
											color="success"
										/>
									</Stack>
								</AccordionDetails>
							</Accordion>
							<Accordion
								sx={{
									boxShadow: "none",
									backgroundColor: "transparent",
									margin: "12px 0 0!important",
									"&::before": {
										display: "none",
									},
								}}
							>
								<AccordionSummary
									expandIcon={<div className="material-icons">keyboard_arrow_right</div>}
									sx={{
										padding: 0,
										margin: 0,
										flexDirection: "row-reverse",
										"& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
											transform: "rotate(90deg)",
										},
										"& .MuiTypography-root": {
											fontFamily: "Roboto-Regular",
										},
										"&.Mui-expanded": {
											minHeight: "48px",
										},
										"& .MuiAccordionSummary-content.Mui-expanded": {
											margin: "12px 0",
										},
									}}
								>
									{t("locations.add.insurance")}
								</AccordionSummary>
								<AccordionDetails
									sx={{
										padding: "10px 0 0",
										width: "100%",
									}}
								>
									<Stack spacing={{ xy: 1, sm: 2 }}>
										<TextField
											name="insuredName"
											value={Location.insuredName}
											onChange={handleChange}
											label={t("locations.add.insuredName")}
											inputProps={{ maxLength: 180 }}
											variant="outlined"
											color="success"
										/>
										<TextField
											name="insuredCode"
											value={Location.insuredCode}
											onChange={handleChange}
											label={t("locations.add.insuredCode")}
											inputProps={{ maxLength: 50 }}
											variant="outlined"
											color="success"
										/>
										<LocalizationProvider
											dateAdapter={AdapterDayjs}
											adapterLocale={context.language === "cn" ? "zh" : "en"}

										>
											<DatePicker
												label={t("locations.add.inceptionDate")}
												value={Location.inceptionDate}
												format="YYYY-MM-DD"
												onChange={(event) => {
													handleChange({ target: { name: "inceptionDate", value: event } });
												}}
												sx={{
													"& .MuiInputLabel-root.Mui-focused": {
														color: "green",
													},
													"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
														borderColor: "green",
													},
												}}
											/>
											<DatePicker
												label={t("locations.add.expirationDate")}
												value={Location.expirationDate}
												format="YYYY-MM-DD"
												onChange={(event) => {
													handleChange({ target: { name: "expirationDate", value: event } });
												}}
												sx={{
													"& .MuiInputLabel-root.Mui-focused": {
														color: "green",
													},
													"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
														borderColor: "green",
													},
												}}
											/>
											<DatePicker
												label={t("locations.add.evaluationDate")}
												value={Location.evaluationDate}
												format="YYYY-MM-DD"
												onChange={(event) => {
													handleChange({ target: { name: "evaluationDate", value: event } });
												}}
												sx={{
													"& .MuiInputLabel-root.Mui-focused": {
														color: "green",
													},
													"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
														borderColor: "green",
													},
												}}
											/>
										</LocalizationProvider>
										<TextField
											name="perilsCovered"
											value={Location.perilsCovered}
											onChange={handleChange}
											label={t("locations.add.perilsCovered")}
											inputProps={{ maxLength: 120 }}
											variant="outlined"
											color="success"
										/>
										<FormControl fullWidth >
											<InputLabel color="success" >{t("locations.add.occupancy")}</InputLabel>
											<Select
												name="occupancy"
												value={Location.occupancy}
												onChange={handleChange}
												label={t("locations.add.occupancy")}
												color="success"
												MenuProps={{
													PaperProps: {
														style: {
															maxHeight: 350,
														},
													},
												}}
											>
												{OccupancyOptions.map((item) => (<MenuItem value={item.name} key={item.name}>{t("occupancyOptions." + item.name)}</MenuItem>))}
											</Select>
										</FormControl>
										<NumericFormat
											customInput={TextField}
											allowNegative={false}
											name="numberOfRisks"
											value={Location.numberOfRisks}
											label={t("locations.add.numberOfRisks")}
											error={Boolean(errors.numberOfRisks)}
											helperText={errors.numberOfRisks}
											onValueChange={(values) => handleChange({ target: { name: 'numberOfRisks', value: values.value, dataset: { needNumber: true } } })}
											thousandSeparator=","
											decimalSeparator="."
											inputMode="decimal"
											variant="outlined"
											color="success"
											type="text"
										/>
										<NumericFormat
											customInput={TextField}
											allowNegative={false}
											name="building"
											value={Location.building}
											label={t("locations.add.building")}
											error={Boolean(errors.building)}
											helperText={errors.building}
											onValueChange={(values) => handleChange({ target: { name: 'building', value: values.value, dataset: { needNumber: true } } })}
											thousandSeparator=","
											decimalSeparator="."
											inputMode="decimal"
											variant="outlined"
											color="success"
											type="text"
										/>
										<NumericFormat
											customInput={TextField}
											allowNegative={false}
											name="content"
											value={Location.content}
											label={t("locations.add.content")}
											error={Boolean(errors.content)}
											helperText={errors.content}
											onValueChange={(values) => handleChange({ target: { name: 'content', value: values.value, dataset: { needNumber: true } } })}
											thousandSeparator=","
											decimalSeparator="."
											inputMode="decimal"
											variant="outlined"
											color="success"
											type="text"
										/>
										<NumericFormat
											customInput={TextField}
											allowNegative={false}
											name="businessInterruption"
											value={Location.businessInterruption}
											label={t("locations.add.businessInterruption")}
											error={Boolean(errors.businessInterruption)}
											helperText={errors.businessInterruption}
											onValueChange={(values) => handleChange({ target: { name: 'businessInterruption', value: values.value, dataset: { needNumber: true } } })}
											thousandSeparator=","
											decimalSeparator="."
											inputMode="decimal"
											variant="outlined"
											color="success"
											type="text"
										/>
										<NumericFormat
											customInput={TextField}
											allowNegative={false}
											name="propertyDamage"
											value={Location.propertyDamage}
											label={t("locations.add.propertyDamage")}
											error={Boolean(errors.propertyDamage)}
											helperText={errors.propertyDamage}
											onValueChange={(values) => handleChange({ target: { name: 'propertyDamage', value: values.value, dataset: { needNumber: true } } })}
											thousandSeparator=","
											decimalSeparator="."
											inputMode="decimal"
											variant="outlined"
											color="success"
											type="text"
										/>
										<NumericFormat
											customInput={TextField}
											allowNegative={false}
											name="limit"
											value={Location.limit}
											label={t("locations.add.limit")}
											error={Boolean(errors.limit)}
											helperText={errors.limit}
											onValueChange={(values) => handleChange({ target: { name: 'limit', value: values.value, dataset: { needNumber: true } } })}
											thousandSeparator=","
											decimalSeparator="."
											inputMode="decimal"
											variant="outlined"
											color="success"
											type="text"
										/>
										<NumericFormat
											customInput={TextField}
											allowNegative={false}
											name="deductible"
											value={Location.deductible}
											label={t("locations.add.deductible")}
											error={Boolean(errors.deductible)}
											helperText={errors.deductible}
											onValueChange={(values) => handleChange({ target: { name: 'deductible', value: values.value, dataset: { needNumber: true } } })}
											thousandSeparator=","
											decimalSeparator="."
											inputMode="decimal"
											variant="outlined"
											color="success"
											type="text"
										/>
										<NumericFormat
											customInput={TextField}
											allowNegative={false}
											name="other"
											value={Location.other}
											label={t("locations.add.other")}
											error={Boolean(errors.other)}
											helperText={errors.other}
											onValueChange={(values) => handleChange({ target: { name: 'other', value: values.value, dataset: { needNumber: true } } })}
											thousandSeparator=","
											decimalSeparator="."
											inputMode="decimal"
											variant="outlined"
											color="success"
											type="text"
										/>
										<NumericFormat
											customInput={TextField}
											allowNegative={false}
											name="total"
											value={Location.total}
											label={t("locations.add.total")}
											error={Boolean(errors.total)}
											helperText={errors.total}
											onValueChange={(values) => handleChange({ target: { name: 'total', value: values.value, dataset: { needNumber: true } } })}
											thousandSeparator=","
											decimalSeparator="."
											inputMode="decimal"
											variant="outlined"
											color="success"
											type="text"
										/>
									</Stack>
								</AccordionDetails>
							</Accordion>
						</Stack>
					</div>
					<div className={styles.footer}>
						<div>
							<Button
								type="submit"
								variant="contained"
								disabled={disabled}
								onClick={save}
								color="success"
							>
								{t("buttons.save")}
							</Button>
							{isChange && (
								<Button
									variant="text"
									onClick={cancel}
									color="success"
									style={{ marginLeft: "10px" }}
								>
									{t("buttons.cancel")}
								</Button>
							)}
						</div>
						{context.leftPanel === LeftPanel.EditLocation && (
							<Button
								variant="text"
								onClick={handleDelete}
								color="error"
							>
								{t("buttons.delete")}
							</Button>
						)}
					</div>
				</>
			)}

			<Modal
				header={t("locations.add.leaveTitle")}
				opened={isClose}
				onClose={handleClose}
			>
				<div className={styles.info}>
					<div className={styles.text}>{t("locations.add.leaveMessage")}</div>

					<div className={styles.button}>
						<Button
							variant="text"
							color="success"
							onClick={handleClose}
							style={{ marginRight: "10px" }}
						>
							{t("buttons.cancel")}
						</Button>
						<Button
							variant="outlined"
							color="success"
							onClick={close}
							style={{ marginRight: "10px" }}
						>
							{t("buttons.leave")}
						</Button>
						<Button
							variant="contained"
							type="submit"
							disabled={disabled}
							onClick={save}
							color="success"
						>
							{t("buttons.save")}
						</Button>
					</div>
				</div>
			</Modal>
		</div>
	);
}

